import React from "react";
import { useTranslation } from "react-i18next";
import {
  FacebookShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  FacebookIcon,
  EmailShareButton,
  EmailIcon,
  TwitterIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
} from "react-share";

const FollowUs = () => {
  const { t } = useTranslation();
  const shareUrl = window.location.origin;
  return (
    <div className="col-md-6 col-lg-12">
      <div className="blog-filter">
        <h3>{t("follow us")}</h3>
        <ul className="blog-icon">
          <li>
            <FacebookShareButton url={shareUrl}>
              <FacebookIcon size={30} round={true} />
            </FacebookShareButton>
          </li>

          <li>
            <TwitterShareButton url={shareUrl}>
              <TwitterIcon size={30} round={true} />
            </TwitterShareButton>
          </li>
          <li>
            <WhatsappShareButton url={shareUrl}>
              <WhatsappIcon size={30} round={true} />
            </WhatsappShareButton>
          </li>
          <li>
            <FacebookMessengerShareButton url={shareUrl}>
              <FacebookMessengerIcon size={30} round={true} />
            </FacebookMessengerShareButton>
          </li>
          <li>
            <EmailShareButton url={shareUrl}>
              <EmailIcon size={30} round={true} />
            </EmailShareButton>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default FollowUs;
